<template>
  <div style="min-height: 300px">
    <vue-affix-box :z-index="11">
      <my-header :menus="menuList" />
    </vue-affix-box>
    <div style="padding: 20px 20px">
      <router-view />
    </div>
  </div>
</template>

<script>
import VueAffixBox from "vue-affix-box/src/vue-affix-box.vue";
import myHeader from "./header.vue";
import { getMenus } from "./menus";

export default {
  components: {
    myHeader,
    VueAffixBox,
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      isReckonCollapse: false,
      userProfile: null,
      menuList: [],
    };
  },
  watch: {
    "$route.path": function () {
      this.fetchuserProfile();
    },
    userProfile() {
      this.refreshMenuList();
    },
    adminNickname() {
      this.refreshMenuList();
      this.refreshWatermark();
    },
  },
  computed: {
    noFrame() {
      return this.$route && this.$route.query && this.$route.query.noFrame == 1;
    },
    adminNickname() {
      return [this.readState("userProfile.nickname")]
        .filter((item) => {
          return !!item;
        })
        .join(" - ");
    },
  },
  methods: {
    handleReckonCollapse(reckonCollapse) {
      this.isReckonCollapse = reckonCollapse;
    },
    handleMenuClick(menu) {
      if (!menu.path) {
        return;
      }
      if (menu.type == "drawer") {
        this.openRouteDrawer(menu.path);
      } else {
        this.openRoutePage(menu.path);
        return true;
      }
    },
    refreshWatermark() {
      //   this.setWatermark(this.readState("userProfile.customerInfo.name")
      //     + "\n" + this.adminNickname);
    },
    filterMenuItem(menus) {
      return (menus || [])
        .filter((item) => {
          return !item.hidden && this.$hasPower(item.actions);
        })
        .map((item) => {
          return Object.assign({}, item, {
            children: this.filterMenuItem(item.children),
          });
        });
    },
    refreshMenuList() {
      this.menuList = this.filterMenuItem(getMenus());
    },
    fetchuserProfile() {
      this.loading = true;
      this.errorMsg = null;
      this.userProfile = null;
      return this.requestApi("biz.customer.account.auth.profile")
        .then((resp) => {
          this.loading = false;
          this.userProfile = resp.data;
          this.commitState({ userProfile: this.userProfile });
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        });
    },
  },
  mounted() {
    this.fetchuserProfile();
    this.refreshMenuList();
    this.refreshWatermark();
  },
};
</script>
